import { useCallback } from "react";
import { useGetNotificationsForUserQuery } from "graphql/__generated__/hooks";

export type NotificationNewSocketPayload = {
  notification?: unknown;
};

/**
 * Notification unread count from API + socket-triggered refresh.
 */
export function useNotificationUnreadCounts(
  userId: string | undefined,
  socketConnected: boolean,
) {
  const { data, refetch } = useGetNotificationsForUserQuery({
    variables: { userId: userId || "" },
    skip: !userId,
  });

  const refreshUnread = useCallback(() => {
    void refetch();
  }, [refetch]);

  const handleNotificationNewSocket = useCallback(
    (_payload?: NotificationNewSocketPayload) => {
      void refetch();
    },
    [refetch],
  );

  const unreadCount = (data?.notification ?? []).reduce(
    (total, item) => total + (item.already_viewed ? 0 : 1),
    0,
  );

  return {
    unreadCount,
    refreshUnread,
    socketConnected,
    handleNotificationNewSocket,
  };
}
